/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Dashboard_Percent_Of_AverageInputs */



/**
* | output |
* | --- |
* | "{percent}% of average" |
*
* @param {Dashboard_Percent_Of_AverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_percent_of_average = /** @type {((inputs: Dashboard_Percent_Of_AverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Percent_Of_AverageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.percent}% des Durchschnitts`)
	return /** @type {LocalizedString} */ (`${i?.percent}% of average`)
});